import { Injectable, inject } from '@angular/core';
import { EnumObject } from '@card-software/library';
import { forkJoin, Observable } from 'rxjs';
import { AssetEnumsProxyService } from '../proxies/asset/asset-enums.proxy.service';
import { LocalHelperService } from './local-helper.service';
import _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class EnumService {
  private readonly assetEnumsProxyService = inject(AssetEnumsProxyService);
  private readonly localHelperService = inject(LocalHelperService);

  private readonly assetEnumLocalStorageKey = 'assetEnums';

  public loadEnums(): Observable<boolean> {
    localStorage.removeItem(this.assetEnumLocalStorageKey);
    return new Observable<boolean>((observer) => {
      forkJoin([this.assetEnumsProxyService.getAll()]).subscribe({
        next: (response) => {
          localStorage.setItem(this.assetEnumLocalStorageKey, JSON.stringify(response[0]));

          observer.next(true);
          observer.complete();
        },
        error: (error) => {
          console.error('Error loading enums', error);
          observer.next(false);
          observer.complete();
        },
      });
    });
  }

  public getEnum(enumName: string): EnumObject {
    const enumObj = JSON.parse(localStorage.getItem(this.assetEnumLocalStorageKey)!);

    if (!enumObj) {
      this.loadEnums().subscribe({
        next: (response) => {
          if (response) {
            this.getEnum(enumName);
          }
        },
        error: (error) => {
          console.error('Error loading enums', error);
        },
      });
    }
    const obj = enumObj.find((x: { name: string; values: object }) => x.name === enumName);
    if (obj) {
      // Translate enum values
      const translatedValues: Record<string, string> = {};
      for (const key in obj.values) {
        translatedValues[key] = _.startCase(this.localHelperService.getLocalizedValue(obj.values[key]));
      }
      return { name: obj.name, values: translatedValues };
    } else {
      return { name: enumName, values: {} } as EnumObject;
    }
  }
}
